<template>
  <div>
    <!-- Body -->
    <div class="body">
      <div>
        <themed-table
          :headers="this.bedManagerService.jobs.headers"
          :data="transformedData"
          :pagination="{
              perPage: this.bedManagerService.jobs.query.limit,
              total: this.bedManagerService.jobs.total,
              page: Math.floor(this.bedManagerService.jobs.query.skip / this.bedManagerService.jobs.query.limit) + 1
          }"
          :sorting="{
            type: this.bedManagerService.jobs.query.sortProperty === 'devices.tasks.status' ? 'status' : this.bedManagerService.jobs.query.sortProperty || 'created',
            direction: this.bedManagerService.jobs.query.sortDirection || 'desc'
          }"
          :sortingEnabled=true
          :filteringEnabled=false
          :paginationEnabled="this.bedManagerService.jobs.total > this.bedManagerService.jobs.query.limit"
          :tenantSelected="currentTenant"
          :version="version"
          @paginationChange="(event) => {
              this.bedManagerService.jobs.query.skip = this.bedManagerService.jobs.query.limit * (event.page - 1);
              this.bedManagerService.jobs.query = {...this.bedManagerService.jobs.query};
          }"
          @searchChange="(event) => {
            const query = this.bedManagerService.jobs.query;
            query.skip = 0; // Resets skip as the search params change
            let newTenant = null;
            Object.keys(event).forEach((key) => {
              const customHandlers = ['scope', 'deviceCount', 'taskType', 'packageId', 'status'];
              if (!customHandlers.includes(key) && event[key]) query[key] = typeof event[key] === 'string' ? event[key].trim() : event[key];
              else if (key === 'taskType' && event[key]) query[key] = event[key].reduce((accumulator, item) => {
                  accumulator.push(item.value);
                  return accumulator;
                }, []);
              else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
              else if (key === 'deviceCount' && event[key]) query['deviceId'] = typeof event[key] === 'string' ? event[key].trim() : event[key];
              else if (key === 'packageId' && event[key]) query['packageId'] =  event[key].map(item => item.value).join();
              else if (key === 'status' && Array.isArray(event[key])) {
                if (event[key].length) {
                  query['status'] = event[key].map(item => item.value).join(',');
                } else {
                  delete query['status'];
                }
              }
              else delete query[key];
            })
            if (newTenant !== null) {
              Object.keys(query).forEach((prop) => this.bedManagerService.jobs.query[prop] = query[prop]);
              this.bedManagerService.tenants.selected = newTenant;
              if (!newTenant) {
                this.bedManagerService.devices.data = [];
                this.bedManagerService.devices.total = 0;
                this.bedManagerService.jobs.data = [];
                this.bedManagerService.jobs.total = 0;
              }
            } else {
              this.bedManagerService.jobs.query = {...query};
            }
          }"
          @tenantChange="(event) => {
            this.bedManagerService.tenants.selected = event;
            if (!event) {
              this.bedManagerService.devices.data = [];
                this.bedManagerService.devices.total = 0;
                this.bedManagerService.jobs.data = [];
                this.bedManagerService.jobs.total = 0;
            }
          }"
          @sortingChange="(event) => {
            if (event === 'delete') {
              delete this.bedManagerService.jobs.query.sortProperty;
              delete this.bedManagerService.jobs.query.sortDirection;
              this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query };
            } else if (event.type === 'status') {
              this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: 'devices.tasks.status', sortDirection: event.direction };
            } else {
              this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: event.type, sortDirection: event.direction };
            }
          }"
          @rowClick="(event) => {
            setJob(event);
          }"
          :addItem="{ label: 'Job', element: CreateJobs }"
          :refreshEnabled="true"
          @refresh="bedManagerService.fetchJobs()"
        ></themed-table>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
import BedManagerService from "../BedManager.service";
import CreateJobs from "./CreateJobs.vue";
import { OTA_BED_STATUS_TOOLTIP } from "../bed-manager-constants";
import { OTA_BED_ERROR } from "../bed-manager-constants";
import { mapOtaBedStatus } from "../bed-manager-constants";

const moment = require("moment");

const TaskType = {
  OTA: 'OTA',
  Configuration: 'Configuration',
  EnableBedRequest: 'EnableBedRequest',
}

Vue.use(VueToast);
Vue.use(Loading);
Vue.component('themed-table', ThemedTable);

export default {
  name: "Jobs",
  components: { },
  data() {
    return {
      console: console,
      moment: moment,
        // Singleton Pattern Service
        // Contains State and API Requests
      bedManagerService: BedManagerService,

      jobInterval: null,

      CreateJobs: CreateJobs,
    };
  },
  computed: {
     version() {
      return this.bedManagerService ? this.bedManagerService.appVersion : '0.0.0';
    },
    transformedData() {
      if (Array.isArray(this.bedManagerService.jobs.data)) {
        this.bedManagerService.jobs.data.forEach((item) => {
          if (item.created) {
            item.createdFormatted = moment(item.created).format("MMMM Do, YYYY [at] h:mm A");
          }
          if (Array.isArray(item.tasks)) {
            item.tasksMapped = item.tasks.map((task, index) => {
              let entry =  `<span><b>Task ${index + 1}</b>: ${task.type}`;
              entry += '</span>';
              return entry;
            });
            item.tasksFormatted = `<div class="jobs-flex-column">${item.tasksMapped.join(' ')}</div>`;
          }
          if (Array.isArray(item.tasks)) {
            item.tasksPackages = item.tasks.map((task) => {
              const doc = (task.payload && task.payload.document) ? task.payload.document : (task.payload || {});
              if (task.type === TaskType.Configuration) {
                return `<div>${this.formatJSON({set:doc.set, remove:doc.remove})}</div>`;
              }

              if (task.type === TaskType.EnableBedRequest) {
                const doc = (task.payload && task.payload.document) ? task.payload.document : (task.payload || {});
                const enableValue =
                  (doc.EnableBed !== undefined
                    ? doc.EnableBed
                    : (doc.set && doc.set.timers ? doc.set.timers.EnableBed : undefined));

                return `<span><b>Bed Idle</b>: ${enableValue === undefined ? 'true' : String(enableValue)}</span>`;
              }

              // Default OTA / package formatting
              const label = task && task.metadata ? task.metadata.packageLabel : undefined;
              const version = task && task.metadata ? task.metadata.packageVersion : undefined;

              if (label || version) {
                return `<span><b class="jobs-package-label">${label || 'Package'}</b>: ${version || ''}</span>`;
              // }
              }

              // fallback
              return `<span><b>${task.type}</b></span>`;
            });

            item.tasksPackages = `<div class="jobs-flex-column">${item.tasksPackages.join(' ')}</div>`;
          }
          if (Array.isArray(item.devices)) {
            item.devicesMapped = item.devices.reduce((retVal, device) => {
              if (Array.isArray(device.tasks)) {
                device.tasks.forEach((task, index) => {
                  let val = `<span class="jobs-device-row"><b>${device.id}:</b> Task ${index + 1}`;
                  if (task.previousVersion && task.selectedVersion) val += `
                    <span class="jobs-flex-grow">
                      (<small><i>${task.previousVersion} -> ${task.selectedVersion}</i></small>)
                    </span>
                  `;
                  if (task.status) val += `<strong class="jobs-status-highlight">${task.status}</strong>`;
                  val += '</span>';
                  retVal.push(val);
                })
              }
              return retVal;
            }, []);
            item.devicesFormatted = `<div class="jobs-flex-column">${item.devicesMapped.join(' ')}</div>`;
          }
          // Use backend-computed statusReduction, deviceCount, and lastUpdatedAtReduced
          if (item.statusReduction) {
            item.status = `<div class="jobs-status">
              <span class="jobs-status-row">
                <div class="jobs-status-column">
                  ${Object.keys(item.statusReduction.statusCounts).map((key) =>{
                    return `<small>${item.statusReduction.statusCounts[key]} ${this.setStatus(key)}</small>`;
                  }).join('')}
                  <hr class="jobs-hr">
                  <small class="jobs-status-summary">
                    <div class="${this.getJobStatusClass(item)}"></div>
                    <b> ${item.statusReduction.completedDevices} / ${item.statusReduction.totalDevices} Completed</b>
                  </small>
                </div>
              </span>
            </div>`;
          }
          if (item.lastUpdatedAtReduced) {
            item.lastUpdatedAtReduced = moment(item.lastUpdatedAtReduced).format("MMMM Do, YYYY [at] h:mm A");
          }
        })
      }
      return this.bedManagerService.jobs.data;
    },
    currentQuery() {
      if (this.bedManagerService.jobs.query) {
        return this.bedManagerService.jobs.query;
      }
      return null;
    },
    currentTenant() {
      if (this.bedManagerService.tenants) {
        return this.bedManagerService.tenants.selected;
      }
      return null;
    },
  },
  watch: {
    currentQuery() {
      this.bedManagerService.fetchJobs();
    },
    currentTenant() {
      this.bedManagerService.fetchJobs();
    }
  },
  mounted() {
    this.bedManagerService.fetchJobs();
// Set Jobs & Start Poll
    this.jobInterval = setInterval(() => {
      this.bedManagerService.fetchJobs();
    }, this.bedManagerService.DEFAULT_POLL_INTERVAL_IN_SECS * 1000);

// Used as ON DESSTROY
    this.$router.afterEach(() => {
      try {
        clearInterval(this.jobInterval);
      } catch (e) { this.console.log(e); }
    });
  },
   unmounted() {},
    methods: {
     formatJSON(data, indent = 1) {
        const jsonString = JSON.stringify(data, null, indent);
        return jsonString
        .replace(/[{}]/g, '')                                 // remove curly braces
        .replace(/^(\s*)"([^"]+)":/gm, (_, spaces, key) => {
          key = key[0].toUpperCase() + key.slice(1)
          return `${spaces}<strong>${key}</strong>:`})     // bold keys
        .replace(/"([^"]+)"/g, '$1')                          // remove quotes around values
        .replace(/,+(\n|$)/g, '$1')                           // remove trailing commas
        .replace(/^\s*[\r\n]/gm, '')                          // remove empty or whitespace-only lines
        .replace(/^\s{1}(\S)/gm, '$1')                        // remove leading 1 whitespace
        .trimEnd();
    },

    setJob(event, doNavigate = true) {
      if(this.bedManagerService.selectedJob.id != event._id)
        this.bedManagerService.selectedJob = { ...this.bedManagerService.selectedJob,jobData: null, data: [], id: null, taskStatusMetrics: [], displayMetrice: false };

      this.bedManagerService.selectedJob = { ...this.bedManagerService.selectedJob, id: event._id, jobData: event };
      if (doNavigate) {
        setTimeout(() => this.bedManagerService.tabIndex = 0, 15);
        setTimeout(() => this.bedManagerService.tabIndex = 3, 25);
      }
    },

    setStatus(status) {
      return mapOtaBedStatus(status);
    },

    setErrorMessage(error) {
      if (error in OTA_BED_ERROR) {
        return OTA_BED_ERROR[error];
      }
      return error;
    },

    getJobStatusClass(item) {
      const statusClassMap = { success: 'isReady', inProgress: 'isInProgress', failed: 'isNotReady' };
      return statusClassMap[item.jobStatus] || 'isNotReady';
    },
  },
};
</script>

<!-- Header Styles -->
<style lang="scss" scoped>
.page-header {
  &__flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__statistics {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__statistics-item {
    font-size: .7em;
    display: flex;
    flex-direction: column;
  }
}

.body {
  &__inner {
    padding: 15px;
  }
}
</style>

<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}</style>

<style lang="scss">
  .jobs-flex-column {
    display: flex;
    flex-direction: column;
  }

  .jobs-device-row {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .jobs-flex-grow {
    flex: 1;
  }

  .jobs-status-highlight {
    color: #1dd8f6;
  }

  .jobs-status {
    display: flex;
    flex-direction: column;
  }

  .jobs-status-row {
    display: flex;
    align-items: flex-start;
    gap: 5px;
  }

  .jobs-status-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .jobs-hr {
    margin: 0;
    border: 0;
    border-top: 1px solid #eee;
  }

  .jobs-status-summary {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .jobs-package-label {
    word-break: break-word;
  }
</style>
